import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { HeadModal } from "./DialogsStyles";
import { PRIMARY_COLOR } from "./../../utils/const";
import { AiFillCloseCircle } from "react-icons/ai";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const GenericDialog = (props) => {
  const { openDialog, setOpenDialog, execute, content, style } = props;
  const open = openDialog;
  const [isLoad, setIsLoad] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleExecute = async () => {
    setIsLoad(true);
    await execute();
    setIsLoad(false);
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": style,
        }}
      >
        <HeadModal>
          <div className="title">
            <img
              src="https://icons-greendragon.s3.us-east-2.amazonaws.com/other/d-decimetrix.png"
              alt=""
              className="neurona"
            />
            <span className="titleHeadModal">{content.title}</span>
          </div>
          <Button onClick={handleClose}>
            <AiFillCloseCircle
              style={{ color: "#FFF", fontSize: 21, marginBottom: -4 }}
            />
          </Button>
        </HeadModal>
        <DialogTitle
          id="responsive-dialog-title"
          style={{
            marginTop: "50px",
          }}
        ></DialogTitle>
        <DialogContent>
          <DialogContentText>{content.description}</DialogContentText>
          {content.content}
        </DialogContent>
        <DialogActions>
          {content.disagree && (
            <Button
              onClick={handleClose}
              style={{
                background: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                color: "#fff",
              }}
            >
              {content.disagree}
            </Button>
          )}
          {content.agree && (
            <Button
              onClick={handleExecute}
              autoFocus
              style={{
                background: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                color: "#fff",
                margin: "10px 40px 10px 30px",
                width: "100%",
              }}
            >
              {isLoad ? <CircularProgress /> : content.agree}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GenericDialog;
